import { combineReducers } from 'redux';
import {
  INVENTORY_SUPPLIER_SET_SUPPLIERS,
  INVENTORY_SUPPLIER_SET_OUTLETS,
  INVENTORY_SUPPLIER_SET_PROFILE,
  INVENTORY_SUPPLIER_OPEN_RIGHT_COLUMN,
  INVENTORY_SUPPLIER_CLOSE_RIGHT_COLUMN,
  INVENTORY_SUPPLIER_SET_SUPPLIER_DETAIL,
  INVENTORY_SUPPLIER_OPEN_DELETE_SUPPLIER_MODAL,
  INVENTORY_SUPPLIER_CLOSE_DELETE_SUPPLIER_MODAL,
  INVENTORY_SUPPLIER_IS_SUBMITTING_FORM,
  INVENTORY_SUPPLIER_EXPORT_START,
  INVENTORY_SUPPLIER_EXPORT_DONE,
  INVENTORY_SUPPLIER_SET_ASYNCJOBID,
} from 'actions/inventory/supplier/constants';

import createReducer from 'utils/createReducer';

const idAsyncJob = createReducer(null, {
  [INVENTORY_SUPPLIER_SET_ASYNCJOBID]: (draft, { payload }) =>
    payload.idAsyncJob,
});

const isExportLoading = createReducer(false, {
  [INVENTORY_SUPPLIER_EXPORT_START]: () => true,
  [INVENTORY_SUPPLIER_EXPORT_DONE]: () => false,
});

const isSubmittingForm = createReducer(false, {
  [INVENTORY_SUPPLIER_IS_SUBMITTING_FORM]: (draft, { payload }) =>
    payload.isSubmittingForm,
});

const openDeleteSupplierModal = createReducer(false, {
  [INVENTORY_SUPPLIER_OPEN_DELETE_SUPPLIER_MODAL]: () => true,
  [INVENTORY_SUPPLIER_CLOSE_DELETE_SUPPLIER_MODAL]: () => false,
});

const openRightColumn = createReducer(false, {
  [INVENTORY_SUPPLIER_OPEN_RIGHT_COLUMN]: () => true,
  [INVENTORY_SUPPLIER_CLOSE_RIGHT_COLUMN]: () => false,
});

const outlets = createReducer([], {
  [INVENTORY_SUPPLIER_SET_OUTLETS]: (draft, { payload }) => payload.outlets,
});

const profile = createReducer(
  {},
  {
    [INVENTORY_SUPPLIER_SET_PROFILE]: (draft, { payload }) => payload.profile,
  }
);

const supplierDetail = createReducer(null, {
  [INVENTORY_SUPPLIER_SET_SUPPLIER_DETAIL]: (draft, { payload }) =>
    payload.supplier,
});

const suppliers = createReducer([], {
  [INVENTORY_SUPPLIER_SET_SUPPLIERS]: (draft, { payload }) => payload.suppliers,
});

export default combineReducers({
  idAsyncJob,
  isExportLoading,
  isSubmittingForm,
  openDeleteSupplierModal,
  openRightColumn,
  outlets,
  profile,
  supplierDetail,
  suppliers,
});
